import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listContact } from '../actions/contactActions'
import { contactSearchJson } from '../models/contactModel'

export default function Contacts(props) {
    const [cont, setCont] = useState({})

    const dispatch = useDispatch()
    const contactList = useSelector((state) => state.contactList)
    const { loading, error, contacts } = contactList

    const [searchContacts, setSearchContacts] = useState(contactSearchJson)
    const [searchtxt2, setsearchtxt2] = useState("")

    const searchtxt = props.searchtxt;

    useEffect(() => {
        if (searchtxt != '') {
            if (contacts == undefined || searchtxt != searchtxt2) {
                setSearchContacts({ ...searchContacts, searchtxt: props.searchtxt });
                dispatch(listContact(props.searchtxt))
                setsearchtxt2(searchtxt)
            }
        }
    }, [dispatch, contacts, searchtxt])

    return (
        loading ? (
            <option value="0">loading...</option>
        ) : (
            contacts ? (
                (contacts.length > 0) ? (
                    contacts?.map(invtyp => (
                        <option value={invtyp.Contact_Id}>{invtyp.ContactName} - {invtyp.Email_Address}</option>
                    ))
                ) : (
                    <option value="0">No Record Exist!</option>
                )
            ) : (
                <option value="0">{error}</option>
            )
        )
    )
}
